import { Stack } from '@mui/material';
import { useIsDesktop } from 'Hooks';

export const FormSectionWrapper: React.FC = (props) => {
  const isDesktop = useIsDesktop();
  return (
    <Stack
      sx={{
        pt: isDesktop ? '40px' : '24px',
        pb: isDesktop ? undefined : '24px',
        boxShadow: '0px 3px 21px 0px #2D70D926',
        borderRadius: isDesktop ? '24px' : '12px',
        bgcolor: '#FFF',
        mb: '24px',
        maxWidth: isDesktop ? '780px' : '375px',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        px: isDesktop ? undefined : 2,
      }}
    >
      {props.children}
    </Stack>
  );
};
